import Vue from 'vue';
import { ISendEmailParams } from '../../models/EmailSendInterface';
import {
  ADD_INBOX,
  SET_CONTACT_LIST,
  SET_SELECTED_CONTACT,
  SET_SELECTED_INBOX,
  SET_EMAIL,
  SET_EMAIL_CREDENTIALS,
  SET_EMAIL_LIST,
  SET_CURRENT_PAGE,
  SET_SEND_EMAIL,
  SET_EMAIL_LIST_DATA,
  SET_STATISTICS,
  UPDATE_STATISTICS,
  SET_LOADING_EMAIL,
  SET_SELECTED_CONTACTCC,
  SET_SELECTED_CONTACTCCO,
  SET_EMAIL_CONTACT,
} from './mutations.types';

const mutations = {
  [ADD_INBOX](state, inbox) {
    state.listInbox.push(inbox);
  },
  [SET_CONTACT_LIST](state, contacts) {
    state.contactList = contacts;
  },
  [SET_SELECTED_CONTACT](state, contacts) {
    state.selectedContacts = contacts;
  },
  [SET_SELECTED_CONTACTCC](state, contacts) {
    state.selectedContactsCC = contacts;
  },
  [SET_SELECTED_CONTACTCCO](state, contacts) {
    state.selectedContactsCCO = contacts;
  },
  [SET_SELECTED_INBOX](state, inbox) {
    state.selectedEmail = inbox;
  },
  [SET_EMAIL](state, email) {
    state.email = email;
  },
  [SET_EMAIL_CREDENTIALS](state, credentials) {
    state.emailCredentials = credentials;
  },
  [SET_EMAIL_LIST](state, emailList) {
    state.emailList = emailList;
  },
  [SET_EMAIL_LIST_DATA](state, emailListData) {
    Vue.set(state.emailList, 'data', emailListData);
  },
  [SET_CURRENT_PAGE](state, currentPage) {
    state.pagination.currentPage = currentPage;
  },
  [SET_SEND_EMAIL](state, sendEmail: ISendEmailParams | null) {
    state.sendEmail = sendEmail;
  },
  [SET_STATISTICS](state, statistics) {
    state.statistics = statistics;
  },
  [UPDATE_STATISTICS](
    state,
    { qtd, read, folder }: { qtd: number; read?: boolean; folder: string },
  ) {
    let statisticIndex = 0;
    if (!state.statistics) return;
    const statistic = state.statistics.find((statistic, index) => {
      if (statistic.agent_mail_box_folder === folder) {
        statisticIndex = index;
        return statistic;
      }
    });
    if (!statistic) return;
    if (!read) {
      statistic.unread_count += qtd;
    } else {
      statistic.unread_count -= qtd;
    }
    statistic.unread_count =
      statistic.unread_count < 0 ? 0 : statistic.unread_count;
    Vue.set(state.statistics, statisticIndex, statistic);
  },
  [SET_LOADING_EMAIL](state, loading) {
    state.emailLoading = loading;
  },
  [SET_EMAIL_CONTACT](state, contact) {
    state.emailContact = contact;
  },
};

export default mutations;
